/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceRunbookOptions = {
  value: FinVoiceRunbook;
  text: string;
};

export type FinVoiceRunbook =
  | 'none'
  | 'general_faq'
  | 'procedure_toast_tap'
  | 'card_reader_troubleshooting'
  | 'caller_identification_workflow'
  | 'identify_device_models'
  | 'network_offline'
  | 'nfc_only_elo_terminal'
  | 'troubleshooting_toast_app_for_card_reader_issues'
  | 'card_reader_support_app_usage'
  | 'cancel_subscription'
  | 'dynamag_msr_not_working'
  | 'toast_msr_on_elo'
  | 'toast_msr_on_flex'
  | 'single_function_toast_tap_elo'
  | 'single_function_toast_tap_flex'
  | 'dual_reader_elo_msr_not_working'
  | 'dual_reader_elo_toast_tap_not_working'
  | 'dual_reader_flex_toast_msr_not_working'
  | 'dual_reader_flex_toast_tap_not_working'
  | 'all_function_on_elo'
  | 'all_functions_toast_tap_flex'
  | 'toast_go_3_troubleshooting'
  | 'toast_go_2_troubleshooting'
  | 'card_reader_troubleshooting_guide'
  | 'card_reader_troubleshooting_intro'
  | 'heliosx_order_tracking'
  | 'time_off_request'
  | 'time_off_request_battlecreek'
  | 'time_off_request_ach_foods'
  | 'time_off_request_new_century'
  | 'time_off_request_springfield'
  | 'time_off_request_fermont'
  | 'time_off_request_muscatine'
  | 'time_off_request_winchester'
  | 'time_off_request_franklin_park'
  | 'time_off_request_bloomfield'
  | 'time_off_request_spruance'
  | 'parkbee_garage_details'
  | 'parkbee_open_garage'
  | 'where_is_my_order'
  | 'where_is_my_order_silencershop'
  | 'ryanair_online_checkin'
  | 'maytronics_warranty_check'
  | 'maytronics_service_status_lookup'
  | 'vet_booking_triage';

export interface FinVoiceRunbookGroup {
  heading?: string;
  items: FinVoiceRunbookOptions[];
}

export interface FinVoiceProcedure {
  id: string;
  name: string;
}

// Dictionary mapping runbook keys to their feature flags
export const FIN_VOICE_RUNBOOK_FEATURE_FLAGS: Partial<Record<FinVoiceRunbook, string>> = {
  cancel_subscription: 'answerbot-fin-voice-cancel-subscription-runbook',
  heliosx_order_tracking: 'answerbot-fin-voice-heliosx-order-tracking-runbook',
  time_off_request: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_battlecreek: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_ach_foods: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_new_century: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_springfield: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_fermont: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_muscatine: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_winchester: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_franklin_park: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_bloomfield: 'answerbot-fin-voice-time-off-request-runbook',
  time_off_request_spruance: 'answerbot-fin-voice-time-off-request-runbook',
  parkbee_garage_details: 'answerbot-fin-voice-parkbee-garage-details-runbook',
  parkbee_open_garage: 'answerbot-fin-voice-parkbee-open-garage-runbook',
  procedure_toast_tap: 'answerbot-fin-voice-procedure-toast-tap-runbook',
  where_is_my_order: 'answerbot-fin-voice-where-is-my-order-runbook',
  where_is_my_order_silencershop: 'answerbot-fin-voice-where-is-my-order-silencershop-runbook',
  ryanair_online_checkin: 'answerbot-fin-voice-ryanair-online-checkin-runbook',
  maytronics_warranty_check: 'answerbot-fin-voice-maytronics-warranty-check-runbook',
  maytronics_service_status_lookup: 'answerbot-fin-voice-maytronics-service-status-lookup-runbook',
  vet_booking_triage: 'answerbot-fin-voice-vet-booking-triage',
};

// Non-Toast runbooks (always available, behind feature flags)
export const FIN_VOICE_NON_TOAST_RUNBOOK_OPTIONS: FinVoiceRunbookGroup[] = [
  // Priority options (no heading)
  {
    items: [
      { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
      {
        value: 'cancel_subscription',
        text: 'ai-agent.voice-playground.settings.runbook-cancel-subscription',
      },
      {
        value: 'heliosx_order_tracking',
        text: 'ai-agent.voice-playground.settings.runbook-heliosx-order-tracking',
      },
      {
        value: 'time_off_request',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request',
      },
      {
        value: 'time_off_request_battlecreek',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-battlecreek',
      },
      {
        value: 'time_off_request_springfield',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-springfield',
      },
      {
        value: 'time_off_request_fermont',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-fermont',
      },
      {
        value: 'time_off_request_muscatine',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-muscatine',
      },
      {
        value: 'time_off_request_winchester',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-winchester',
      },
      {
        value: 'time_off_request_franklin_park',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-franklin-park',
      },
      {
        value: 'time_off_request_bloomfield',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-bloomfield',
      },
      {
        value: 'time_off_request_ach_foods',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-ach-foods',
      },
      {
        value: 'time_off_request_new_century',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-new-century',
      },
      {
        value: 'time_off_request_spruance',
        text: 'ai-agent.voice-playground.settings.runbook-time-off-request-spruance',
      },
      {
        value: 'parkbee_garage_details',
        text: 'ai-agent.voice-playground.settings.runbook-parkbee-garage-details',
      },
      {
        value: 'parkbee_open_garage',
        text: 'ai-agent.voice-playground.settings.runbook-parkbee-open-garage',
      },
      {
        value: 'where_is_my_order',
        text: 'ai-agent.voice-playground.settings.runbook-where-is-my-order',
      },
      {
        value: 'where_is_my_order_silencershop',
        text: 'ai-agent.voice-playground.settings.runbook-where-is-my-order-silencershop',
      },
      {
        value: 'procedure_toast_tap',
        text: 'ai-agent.voice-playground.settings.runbook-procedure-toast-tap',
      },
      {
        value: 'ryanair_online_checkin',
        text: 'ai-agent.voice-playground.settings.runbook-ryanair-online-checkin',
      },
      {
        value: 'maytronics_warranty_check',
        text: 'ai-agent.voice-playground.settings.runbook-maytronics-warranty-check',
      },
      {
        value: 'maytronics_service_status_lookup',
        text: 'ai-agent.voice-playground.settings.runbook-maytronics-service-status-lookup',
      },
      {
        value: 'vet_booking_triage',
        text: 'ai-agent.voice-playground.settings.runbook-vet-appointment-type-triage',
      },
    ],
  },
];

// Toast-specific runbooks (only for Toast customers)
export const FIN_VOICE_TOAST_RUNBOOK_OPTIONS: FinVoiceRunbookGroup[] = [
  // Priority options (no heading)
  {
    items: [
      {
        value: 'general_faq',
        text: 'ai-agent.voice-playground.settings.runbook-general-faq',
      },
      {
        value: 'caller_identification_workflow',
        text: 'ai-agent.voice-playground.settings.runbook-caller-identification-workflow',
      },
      {
        value: 'card_reader_troubleshooting_guide',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting-guide',
      },
      {
        value: 'card_reader_troubleshooting_intro',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting-intro',
      },
    ],
  },
  // Card Reader Issues
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-card-reader',
    items: [
      {
        value: 'troubleshooting_toast_app_for_card_reader_issues',
        text: 'ai-agent.voice-playground.settings.runbook-troubleshooting-toast-app-for-card-reader-issues',
      },
      {
        value: 'card_reader_support_app_usage',
        text: 'ai-agent.voice-playground.settings.runbook-card-reader-support-app-usage',
      },
      {
        value: 'dynamag_msr_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-dynamag-msr-not-working',
      },
      {
        value: 'toast_msr_on_elo',
        text: 'ai-agent.voice-playground.settings.runbook-toast-msr-on-elo',
      },
      {
        value: 'toast_msr_on_flex',
        text: 'ai-agent.voice-playground.settings.runbook-toast-msr-on-flex',
      },
      {
        value: 'single_function_toast_tap_elo',
        text: 'ai-agent.voice-playground.settings.runbook-single-function-toast-tap-elo',
      },
      {
        value: 'single_function_toast_tap_flex',
        text: 'ai-agent.voice-playground.settings.runbook-single-function-toast-tap-flex',
      },
      {
        value: 'dual_reader_elo_msr_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-dual-reader-elo-msr-not-working',
      },
      {
        value: 'dual_reader_elo_toast_tap_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-dual-reader-elo-toast-tap-not-working',
      },
      {
        value: 'dual_reader_flex_toast_msr_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-dual-reader-flex-toast-msr-not-working',
      },
      {
        value: 'dual_reader_flex_toast_tap_not_working',
        text: 'ai-agent.voice-playground.settings.runbook-dual-reader-flex-toast-tap-not-working',
      },
      {
        value: 'all_function_on_elo',
        text: 'ai-agent.voice-playground.settings.runbook-all-function-on-elo',
      },
      {
        value: 'all_functions_toast_tap_flex',
        text: 'ai-agent.voice-playground.settings.runbook-all-functions-toast-tap-flex',
      },
      {
        value: 'toast_go_3_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-toast-go-3-troubleshooting',
      },
      {
        value: 'toast_go_2_troubleshooting',
        text: 'ai-agent.voice-playground.settings.runbook-toast-go-2-troubleshooting',
      },
      {
        value: 'identify_device_models',
        text: 'ai-agent.voice-playground.settings.runbook-identify-device-models',
      },
    ],
  },
  // Networking
  {
    heading: 'ai-agent.voice-playground.settings.runbook-group-networking',
    items: [
      {
        value: 'network_offline',
        text: 'ai-agent.voice-playground.settings.runbook-network-offline',
      },
    ],
  },
];

/**
 * Get runbook options based on whether Toast runbooks should be included
 * @param includeToast - Whether to include Toast-specific runbooks
 * @returns Combined runbook groups
 */
export function getRunbookOptions(includeToast = false): FinVoiceRunbookGroup[] {
  if (!includeToast) {
    return FIN_VOICE_NON_TOAST_RUNBOOK_OPTIONS;
  }

  // Combine non-Toast and Toast options
  return [...FIN_VOICE_NON_TOAST_RUNBOOK_OPTIONS, ...FIN_VOICE_TOAST_RUNBOOK_OPTIONS];
}

/**
 * Get the translation key (label) for a given runbook
 * Searches all runbooks regardless of the toast flag
 * @param runbook - The runbook value
 * @returns The translation key for the runbook, or undefined if not found or 'none'
 */
export function getLabelForRunbook(runbook: FinVoiceRunbook): string | undefined {
  if (runbook === 'none') {
    return undefined;
  }

  // Search in non-Toast runbooks first
  for (let group of FIN_VOICE_NON_TOAST_RUNBOOK_OPTIONS) {
    let option = group.items.find((item) => item.value === runbook);
    if (option) {
      return option.text;
    }
  }

  // Search in Toast runbooks
  for (let group of FIN_VOICE_TOAST_RUNBOOK_OPTIONS) {
    let option = group.items.find((item) => item.value === runbook);
    if (option) {
      return option.text;
    }
  }

  return undefined;
}
